<script lang="ts">
  import { config } from "$lib/config";
  import type { definitions } from "$lib/types/supabase";

  export let size_px: number = 48;
  export let algo_use: definitions["algo_uses"];

  const lnl_colours = config.ui.colours;
</script>

<div class="media">
  <div class="media-left">
    <figure class="image is-{size_px}x{size_px}">
      <img
        src={`https://source.boringavatars.com/pixel/${size_px}/${
          algo_use.slug
        }?colors=${lnl_colours.map((i) => i.split("#")[1]).join(",")}&square`}
        alt="Algorithm identifier"
      />
    </figure>
  </div>
  <div class="media-content">
    <p class="title is-4">{algo_use.title}</p>
    <p class="subtitle is-6 is-family-monospace">{algo_use.slug}</p>
  </div>
</div>
